import { Subject } from 'rxjs';

import type { BuzzerBlueprintRunNotifications, BuzzerNotifications, BuzzerOnlineDevicesNotifications } from './types';

export const buzzerNotifications$ = new Subject<BuzzerNotifications>();
export const buzzerOnlineDevicesNotifications$ = new Subject<BuzzerOnlineDevicesNotifications>();
export const buzzerBlueprintRunNotifications$ = new Subject<BuzzerBlueprintRunNotifications>();
